// Toast Notification Component

import React, { ReactNode } from 'react';
import './Toast.css';

export interface ToastProps {
  type: 'success' | 'error' | 'warning' | 'info';
  title: string;
  message?: string;
  onClose: () => void;
}

export function Toast({ type, title, message, onClose }: ToastProps) {
  const icons = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ'
  };

  const colors = {
    success: '#10b981',
    error: '#ef4444',
    warning: '#f59e0b',
    info: '#3b82f6'
  };

  return (
    <div className={`toast toast-${type}`} style={{ borderLeftColor: colors[type] }}>
      <div className="toast-icon" style={{ color: colors[type] }}>
        {icons[type]}
      </div>
      <div className="toast-content">
        <div className="toast-title">{title}</div>
        {message && <div className="toast-message">{message}</div>}
      </div>
      <button className="toast-close" onClick={onClose} aria-label="Benachrichtigung schließen">
        ×
      </button>
    </div>
  );
}

export function ToastContainer({ children }: { children: ReactNode }) {
  return <div className="toast-container">{children}</div>;
}
